export const getLabelValuePairsFromEnum = (zodEnum, labelsMap) => Object.values(zodEnum.Values).map((value) => ({
    label: labelsMap ? labelsMap[value] : value,
    value,
}));
